/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonInput, IonSelect, IonTextarea } from '@ionic/angular';
import { takeUntil, debounceTime, Subject } from 'rxjs';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { QuestionnaireSharedService } from 'src/app/services/questionnaire-shared.service';
import { QuestionSaveService } from 'src/app/services/question-save.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit, OnDestroy {
  @Input() question: any;
  @Input() id: number;
  @Input() parentObject: string;
  @Input() customFormId: number;
  @Input() category: string;
  @Input() routerState: any;
  @ViewChild('select') select: IonSelect;
  @ViewChild('select_multiple') selectMultiple: IonSelect;
  @ViewChild('textArea') textArea: IonTextarea;
  @ViewChild('date') date: IonInput;
  @ViewChild('time') time: IonInput;
  @ViewChild('number') numberField: IonInput;
  @ViewChild('checkbox') checkbox: IonInput;
  questionAnswer = '';
  dateTemp = '';
  public subject = new Subject<void>();
  public function = '';
  public undersigned = '';
  public signature = '';
  public signaturePath: SafeHtml = '';
  public isSignatureEdit = false;

  public signatureForm: FormGroup;

  constructor(
    fb: FormBuilder,
    private dataService: DataProviderService,
    private router: Router,
    private questionnaireSharedService: QuestionnaireSharedService,
    private domSanitizer: DomSanitizer,
    private questionSaveService: QuestionSaveService
  ) {
    this.signatureForm = fb.group({
      signature: [undefined],
    });
  }

  ngOnInit(): void {
    this.signatureForm.get('signature')?.disable();
    this.subject.pipe(debounceTime(500)).subscribe((data) => {
      this.saveAnswer();
    });

    if (
      this.question.questionAnswers === 'full_width_before' ||
      this.question.questionAnswers === 'question_full_width_before' ||
      this.question.questionAnswers === 'full_width_after' ||
      this.question.questionAnswers === 'question_full_width_after' ||
      this.question.questionAnswers === 'txt' ||
      this.question.questionAnswers === 'number'
    ) {
      if (!this.question.questionAnswer) {
        this.question.questionAnswer = this.question.questionDefaultValue || '';
      }
    }
    if (
      this.question.questionAnswers === 'signature' &&
      this.question.questionAnswer
    ) {
      const signatureJSON = JSON.parse(this.question.questionAnswer);

      this.function = signatureJSON?.Function;
      this.undersigned = signatureJSON?.Undersigned;
      this.signature = signatureJSON?.Signature;
      if (this.signature) {
        this.signaturePath = this.domSanitizer.bypassSecurityTrustHtml(
          this.signature
        );
      }

      this.signatureForm.get('signature')?.setValue(this.signature);
    }
    if (this.question.questionAnswers === 'date') {
      const dateArray = this.question.questionAnswer.split('-');
      this.dateTemp = dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
    }
    if (this.question.type === 'select_multiple') {
      if (!this.question.questionAnswer) {
        this.question.questionAnswer = '[]';
      }

      this.question.questionAnswer = JSON.parse(this.question.questionAnswer);
    }
  }
  ngOnDestroy(): void {}

  routeToPhotos() {
    this.router.navigate(
      [
        'photos',
        this.question.answerId,
        this.question.questionMaxNumberOfPhotos,
        this.question.categoryKey,
        this.question.question,
        this.question.photosCount,
        this.customFormId,
        this.parentObject,
        this.id,
      ],
      { state: this.routerState }
    );
  }
  routeToComments() {
    this.router.navigate(
      [
        'comments',
        this.question.answerId,
        this.question.categoryKey,
        this.question.question,
        this.customFormId,
        this.parentObject,
        this.id,
      ],
      { state: this.routerState }
    );
  }

  saveSignature() {
    this.signatureForm.get('signature')?.disable();
    this.isSignatureEdit = false;
    this.signature = this.signatureForm.value.signature;
    this.signaturePath = this.domSanitizer.bypassSecurityTrustHtml(
      this.signature
    );
    this.saveAnswer();
  }

  saveAnswer() {
    let answer = this.question.questionAnswer;
    if (this.question.type === 'select_multiple') {
      answer = JSON.stringify(this.question.questionAnswer);
    }

    this.questionSaveService.saveAnswer(
      this.question,
      this.signature,
      this.function,
      this.undersigned,
      this.parentObject,
      this.id,
      answer
    );
  }

  openSelect() {
    if (this.question.questionAnswers === 'txt') {
      this.textArea.setFocus();
    } else if (this.question.questionAnswers === 'date') {
      this.date.setFocus();
    } else if (this.question.questionAnswers === 'time') {
      this.time.setFocus();
    } else if (this.question.questionAnswers === 'number') {
      this.numberField.setFocus();
    } else if (this.question.questionAnswers === 'checkbox') {
    }
    // Removed select and multi-select handling since options are now always visible
  }

  setDate() {
    this.question.questionAnswer = this.question.questionAnswer.slice(0, 10);
    const dateArray = this.question.questionAnswer.split('-');
    this.dateTemp = dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
    this.saveAnswer();
  }
  public insertCurrentTime(question): void {
    const current = new Date();
    const hours = String(current.getHours()).padStart(2, '0');
    const minutes = String(current.getMinutes()).padStart(2, '0');
    question.questionAnswer = `${hours}:${minutes}`;
  }
  setTime() {
    if (this.question.questionAnswer.length !== 5) {
      const date = new Date(this.question.questionAnswer);
      this.question.questionAnswer = `${date.getHours()}:${date.getMinutes()}`;
    }
    this.saveAnswer();
  }

  // Options selection methods
  toggleMultiSelectOption(option: string, event?: any) {
    if (!this.question.questionAnswer) {
      this.question.questionAnswer = [];
    }

    const index = this.question.questionAnswer.indexOf(option);
    if (index > -1) {
      this.question.questionAnswer.splice(index, 1);
    } else {
      this.question.questionAnswer.push(option);
    }

    this.saveAnswer();
  }

  isOptionSelected(option: string): boolean {
    if (!this.question.questionAnswer) {
      return false;
    }
    return this.question.questionAnswer.includes(option);
  }

  selectSingleOption(option: string) {
    this.question.questionAnswer = option;
    this.saveAnswer();
  }
}
